<template>
  <div class="home">
    <div class="head flex flex-jsb">
      <div class="head-l flex flex-ac">
        <div class="head-btn flex flex-ac" @click="handleFullScreen"><i class="icon "
            :class="isFullScreen ? 'icon-quxiaoquanping' : 'icon-quanping'" />
          {{ isFullScreen ? '关闭全屏' : '全屏显示' }}</div>
        <div class="head-btn flex flex-ac" @click="handleRefresh"><i class="el-icon-refresh" />刷新</div>
      </div>
      <div class="head-title">智慧停车云岗亭</div>
      <div class="head-r">{{ user.name }}</div>
      <!-- <button @click="handleLoginout">退出</button> -->
    </div>
    <div class="content flex flex-jsb" v-loading="loading">

      <ul class="video-box flex flex-w flex-acb" v-if="gateData.length <= 16">
        <li :class="gateData.length > 9 ? 'li4' : (gateData.length > 4 ? 'li3' : '')" v-for="(item, index) in gateData"
          :key="index">
          <template v-if="item.device && item.device.model_name == 'ice'">
            <img :ref="'iceRef' + item.device.id" />
          </template>
          <!-- <template v-else-if="item.device && item.device.model_name == 'qy'">
            <div class="iframe">
              <img class="video-item" :ref="'iframe' + item.device.id" :src="item.device.local_addr" />
            </div>
          </template> -->
          <template v-else-if="item.device && (item.device.model_name == 'qy' || item.device.model_name == 'hc')">
            <div :id="'rtsp' + item.device.id + index" class="video-item">
              <label
                v-if="item.device.flvfail">地址栏输入chrome://flags/#block-insecure-private-network-requests，将选项Default改为禁用Disable，然后重启浏览器即可。</label>
            </div>
          </template>
          <template v-else-if="item.device && (item.device.model_name == 'xlt')">
            <div :id="'xlt' + item.device.id + index" class="video-item"></div>
          </template>
          <template
            v-else-if="item.device && item.device.local_addr && (item.device.model_name == 'sj' || item.device.local_addr.includes('.flv') || item.device.local_addr.includes('.php') || item.device.model_name == 'xlt')">
            <div class="video-item" :id="'video' + item.id">
              <label
                v-if="item.device.flvfail">地址栏输入chrome://flags/#block-insecure-private-network-requests，将选项Default改为禁用Disable，然后重启浏览器即可。</label>
            </div>
          </template>
          <template v-else-if="item.device && item.device.local_addr && item.device.local_addr.includes('.m3u8')">
            <video class="video-item" v-show="item.device.local_addr" controls autoplay muted
              :id="'myVideo' + item.id + index">
              <source v-if="item.device.local_addr" :src="item.device.local_addr" type="application/x-mpegURL" />
            </video>
          </template>
          <div v-else-if="item.imageSrc" class="video-item">
            <img :src="item.imageSrc" />
          </div>
          <div v-else class="video-item"><label class="off-line">设备离线</label></div>
          <div class="funtion flex flex-jsb flex-ac">
            <div class="funtion-title">
              [{{ item.type }}]{{ item.name }}
            </div>
            <div class="funtion-button flex">
              <div>
                <el-popover placement="top-start" :width="200" trigger="hover"
                  content="如果识别区域没有车牌可供识别，触发后会上报无牌车识别记录，可以用于无牌车手动触发">
                  <template #reference>
                    <el-button type="primary" size="mini" :loading="recognizeLoading"
                      @click="handleRecognize($event, item.id)">手动触发识别</el-button>
                  </template>
                </el-popover>
                <el-button type="primary" size="mini" @click="handleOpenMode(item)">常开({{
                  item.always_open_mode[item.type] == '是' ? '开启' : '关闭' }})</el-button>
              </div>
              <div>
                <el-button type="success" size="mini" v-if="item.talkback"
                  @click="openIntercom(item, index)">对讲</el-button>
                <el-button type="primary" size="mini" :loading="openAndCloseLoading"
                  @click="handleOpenAndClose($event, item.id, 0)">开闸</el-button>
                <el-button type="primary" size="mini" :loading="openAndCloseLoading"
                  @click="handleOpenAndClose($event, item.id, 1)">落闸</el-button>
              </div>
            </div>
          </div>
        </li>

      </ul>
      <el-carousel class="video-box" v-else indicator-position="outside" :height="carouselHeight" :loop="false"
        :autoplay="false">
        <el-carousel-item>
          <ul class=" video-carousel flex flex-w flex-acb">
            <li :class="gateData.length > 9 ? 'li4' : (gateData.length > 4 ? 'li3' : '')"
              v-for="(item, index) in gateData.slice(0, 16)" :key="index">
              <template v-if="item.device && item.device.model_name == 'ice'">
                <img :ref="'iceRef' + item.device.id" />
              </template>
              <!-- <template v-else-if="item.device && item.device.model_name == 'qy'">
                <div class="iframe">
                  <img class="video-item" :ref="'iframe' + item.device.id" :src="item.device.local_addr" />
                </div>
              </template> -->
              <template v-else-if="item.device && (item.device.model_name == 'qy' || item.device.model_name == 'hc')">
                <div :id="'rtsp' + item.device.id + index" class="video-item">
                  <label
                    v-if="item.device.flvfail">地址栏输入chrome://flags/#block-insecure-private-network-requests，将选项Default改为禁用Disable，然后重启浏览器即可。</label>
                </div>
              </template>
              <template v-else-if="item.device && (item.device.model_name == 'xlt')">
                <div :id="'xlt' + item.device.id + index" class="video-item"></div>
              </template>
              <template
                v-else-if="item.device && item.device.local_addr && (item.device.model_name == 'sj' || item.device.local_addr.includes('.flv') || item.device.local_addr.includes('.php') || item.device.model_name == 'xlt')">
                <div class="video-item" :id="'video' + item.id">
                  <label
                    v-if="item.device.flvfail">地址栏输入chrome://flags/#block-insecure-private-network-requests，将选项Default改为禁用Disable，然后重启浏览器即可。</label>
                </div>
              </template>
              <template v-else-if="item.device && item.device.local_addr && item.device.local_addr.includes('.m3u8')">
                <video class="video-item" v-show="item.device.local_addr" controls autoplay muted
                  :id="'myVideo' + item.id + index">
                  <source v-if="item.device.local_addr" :src="item.device.local_addr" type="application/x-mpegURL" />
                </video>
              </template>
              <div v-else-if="item.imageSrc" class="video-item">
                <img :src="item.imageSrc" />
              </div>
              <div v-else class="video-item"><label class="off-line">设备离线</label></div>
              <div class="funtion flex flex-jsb flex-ac">
                <div class="funtion-title">
                  [{{ item.type }}]{{ item.name }}
                </div>
                <div class="funtion-button flex">
                  <div>
                    <el-popover v-if="item.type.includes('入')" placement="top-start" :width="200" trigger="hover"
                      content="如果识别区域没有车牌可供识别，触发后会上报无牌车识别记录，可以用于无牌车手动触发">
                      <template #reference>
                        <el-button type="primary" size="mini" :loading="recognizeLoading"
                          @click="handleRecognize($event, item.id)">手动触发识别</el-button>
                      </template>
                    </el-popover>
                    <el-button type="primary" size="mini" @click="handleOpenMode(item)">常开({{
                      item.always_open_mode[item.type] == '是' ? '开启' : '关闭' }})</el-button>
                  </div>
                  <div>
                    <el-button type="success" size="mini" v-if="item.talkback"
                      @click="openIntercom(item, index)">对讲</el-button>
                    <el-button type="primary" size="mini" :loading="openAndCloseLoading"
                      @click="handleOpenAndClose($event, item.id, 0)">开闸</el-button>
                    <el-button type="primary" size="mini" :loading="openAndCloseLoading"
                      @click="handleOpenAndClose($event, item.id, 1)">落闸</el-button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </el-carousel-item>
        <el-carousel-item>
          <ul class=" video-carousel flex flex-w flex-acb">
            <li :class="gateData.length > 9 ? 'li4' : (gateData.length > 4 ? 'li3' : '')"
              v-for="(item, index) in gateData.slice(16, 32)" :key="index">
              <template v-if="item.device && (item.device.model_name == 'ice' || item.device.model_name == '')">
                <img :ref="'iceRef' + item.device.id" />
              </template>
              <!-- <template v-else-if="item.device && item.device.model_name == 'qy'">
                <div class="iframe">
                  <img class="video-item" :ref="'iframe' + item.device.id" :src="item.device.local_addr" />
                </div>
              </template> -->
              <template v-else-if="item.device && (item.device.model_name == 'qy' || item.device.model_name == 'hc')">
                <div :id="'rtsp' + item.device.id + index" class="video-item">
                  <label
                    v-if="item.device.flvfail">地址栏输入chrome://flags/#block-insecure-private-network-requests，将选项Default改为禁用Disable，然后重启浏览器即可。</label>
                </div>
              </template>
              <template v-else-if="item.device && (item.device.model_name == 'xlt')">
                <div :id="'xlt' + item.device.id + index" class="video-item"></div>
              </template>
              <template
                v-else-if="item.device && item.device.local_addr && (item.device.model_name == 'sj' || item.device.local_addr.includes('.flv') || item.device.local_addr.includes('.php') || item.device.model_name == 'xlt')">
                <div class="video-item" :id="'video' + item.id">

                  <label
                    v-if="item.device.flvfail">地址栏输入chrome://flags/#block-insecure-private-network-requests，将选项Default改为禁用Disable，然后重启浏览器即可。</label>
                </div>
              </template>
              <template v-else-if="item.device && item.device.local_addr && item.device.local_addr.includes('.m3u8')">
                <video class="video-item" v-show="item.device.local_addr" controls autoplay muted
                  :id="'myVideo' + item.id + index">
                  <source v-if="item.device.local_addr" :src="item.device.local_addr" type="application/x-mpegURL" />
                </video>
              </template>
              <div v-else-if="item.imageSrc" class="video-item">
                <img :src="item.imageSrc" />
              </div>
              <div v-else class="video-item"><label class="off-line">设备离线</label></div>
              <div class="funtion flex flex-jsb flex-ac">
                <div class="funtion-title">
                  [{{ item.type }}]{{ item.name }}
                </div>
                <div class="funtion-button flex">
                  <div>
                    <el-popover v-if="item.type.includes('入')" placement="top-start" :width="200" trigger="hover"
                      content="如果识别区域没有车牌可供识别，触发后会上报无牌车识别记录，可以用于无牌车手动触发">
                      <template #reference>
                        <el-button type="primary" size="mini" :loading="recognizeLoading"
                          @click="handleRecognize($event, item.id)">手动触发识别</el-button>
                      </template>
                    </el-popover>
                    <el-button type="primary" size="mini" @click="handleOpenMode(item)">常开({{
                      item.always_open_mode[item.type] == '是' ? '开启' : '关闭' }})</el-button>
                  </div>
                  <div>
                    <el-button type="success" size="mini" v-if="item.talkback"
                      @click="openIntercom(item, index)">对讲</el-button>
                    <el-button type="primary" size="mini" :loading="openAndCloseLoading"
                      @click="handleOpenAndClose($event, item.id, 0)">开闸</el-button>
                    <el-button type="primary" size="mini" :loading="openAndCloseLoading"
                      @click="handleOpenAndClose($event, item.id, 1)">落闸</el-button>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </el-carousel-item>
      </el-carousel>

      <div class="info">
        <ul class="info-statistics flex flex-ac flex-jsb">
          <li>
            <label>{{ remainData.left }}</label>
            <p>剩余车位</p>
          </li>
          <li v-for="(item, index) in remainData.list" :key="index">
            <label>{{ item.count }}</label>
            <p>{{ item.name }}</p>
          </li>
        </ul>
        <div class="info-car">
          <div class="info-car-title">入口信息</div>
          <div class="info-car-data">
            <ul class="flex flex-w">
              <li class="flex">
                <label>车牌号：</label>
                <p>{{ recordsEntData.car_number }}</p>
              </li>
              <li class="flex">
                <label>车辆类型：</label>
                <p>{{ recordsEntData.type_name || recordsEntData.car_type }}</p>
              </li>
              <li class="flex">
                <label>入场通道：</label>
                <p>{{ recordsEntData.ent_gate_name || recordsEntData.gate_id }}</p>
              </li>
              <li class="flex flex-ac">
                <label>入场时间：</label>
                <p class="info-time">{{ recordsEntData.ent_time || recordsEntData.record_time }}</p>
              </li>
              <li class="flex">
                <label>备注信息：</label>
                <p>{{ recordsEntData.memo }}</p>
              </li>
              <li class="flex">
                <label>抓拍图片：</label>
                <p class="preview-img" @click="previewImg(recordsEntData.ent_pic || recordsEntData.pic)">
                  查看图片
                </p>
              </li>
              <li class="quick">
                <el-button type="primary" size="small" :loading="dialogVisibleLookup" :disabled="!recordsEntData.memo"
                  @click="handleQuick">快捷入场(R)</el-button>
              </li>
            </ul>
          </div>
          <div class="info-car-title flex flex-jsb flex-ac">出口信息
            <el-dropdown placement="bottom" :disabled="pendingNum == 0">
              <el-button type="primary" size="small">
                待处理({{ pendingNum }})
              </el-button>
              <template #dropdown>
                <el-dropdown-menu>
                  <el-dropdown-item v-for="item in pendingList" :key="item.id"
                    v-show="item.car_number != recordsDepData.car_number && item.gate_id != recordsDepData.gate_id"
                    @click="handlePending(item)">
                    {{ item.dep_gate_name + ' - ' + item.car_number }}</el-dropdown-item>
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="info-car-data">
            <ul class="flex flex-w">
              <li class=" flex">
                <label>车牌号：</label>
                <p>{{ recordsDepData.car_number }}</p>
              </li>
              <li class="flex">
                <label>车辆类型：</label>
                <p>{{ recordsDepData.type_name || recordsDepData.car_type }}</p>
              </li>
              <li class="flex">
                <label>入场通道：</label>
                <p>{{ recordsDepData.ent_gate_name }}</p>
              </li>
              <li class="flex flex-ac">
                <label>入场时间：</label>
                <p class="info-time">{{ recordsDepData.ent_time || recordsDepData.record_time }}</p>
              </li>
              <li class="flex">
                <label>出场通道：</label>
                <p>{{ recordsDepData.dep_gate_name }}</p>
              </li>
              <li class="flex">
                <label>停车时长：</label>
                <p>{{ recordsDepData.time_long || recordsDepData.park_time_long || recordsDepData.park_time }}</p>
              </li>
              <li class="flex">
                <label>订单金额：</label>
                <p>{{ recordsDepData.price || 0 }}元<el-button style="margin-left: 6px;"
                    v-if="recordsDepData.is_show_billing == 1" size="mini" plain type="danger"
                    @click="$refs.dialogBilling.init(recordsDepData.record_id || recordsDepData.dep_id)">计费详情</el-button>
                </p>
              </li>
              <li class="flex">
                <label>已付金额：</label>
                <p>{{ recordsDepData.aly_pay_price || 0 }}元</p>
              </li>
              <li class="flex">
                <label>优惠金额：</label>
                <p>{{ recordsDepData.cut_price || 0 }}元</p>
              </li>
              <li class="flex">
                <label>抓拍图片：</label>
                <p class="preview-img" @click="previewImg(recordsDepData.dep_pic || recordsDepData.pic)">
                  查看图片
                </p>
              </li>
              <li class="flex flex-100">
                <label>备注信息：</label>
                <p>{{ recordsDepData.memo }}</p>
              </li>

              <li class="flex flex-ac flex-100">
                <label>计费规则:</label>
                <el-select v-model="prop_rule_id" placeholder="请选择计费规则" size="small" style="width:200px"
                  @change="handleRule">
                  <el-option v-for="(item, index) in ruleList" :key="index" :label="item.title"
                    :value="item.id"></el-option>
                </el-select>
              </li>
              <li class="info-car-cost">
                <label>待缴金额:</label>
                <p>{{ recordsDepData.pay_price || 0 }}元</p>
              </li>


            </ul>
            <div class="info-car-button flex">
              <el-button type="primary" border :disabled="recordsDepData.pay_price == 0" :loading="prePayLoading"
                @click="handlePrePay(recordsDepData)">现金放行(U)</el-button>
              <el-button type="primary" :disabled="recordsDepData.pay_price == 0" :loading="disposeLoading"
                @click="handelDispose(recordsDepData)">不予处理</el-button>
              <el-button
                v-if="recordsDepData.pay_price == 0 && !recordsDepData.dep_time && recordsDepData.pass_type == 0"
                type="primary" :loading="freeDirectionLoading"
                @click="handleFreeDirection(recordsDepData)">开闸放行</el-button>
              <!-- <el-button type="primary" plain @click="handelRefresh">刷新订单</el-button> -->
            </div>
            <el-form class="info-car-reason" :inline="true">
              <el-form-item label="免费原因：">
                <el-select filterable allow-create default-first-option v-model="freeOut" placeholder="请选择免费原因"
                  style="width:200px">
                  <el-option v-for="(item, index) in freeOutList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="medium" :disabled="recordsDepData.pay_price == 0"
                  :loading="freeOutLoading" @click="handleFreeOut(recordsDepData)">免费放行(p)</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="next">
      上一页下一页
    </div> -->
    <div class="footer flex flex-jsb">
      <ul>
        <li @click="handleOutAndEnterRecord('enter')"><i class="icon icon-ru" style="color:#07AD32" />入场记录(Z)</li>
        <li @click="handleOutAndEnterRecord('out')"><i class="icon icon-icon_function_chuku"
            style="color:#0BA4DD" />出场记录(X)
        </li>
        <li @click="handleProhibitRecord"><i class="icon icon-xialingyingicon" style="color:#DD0B0B" />禁止记录(C)
        </li>
        <li @click="handleUnpayRecord"><i class="icon icon-jine" style="color:#DE9A1F" />未缴记录(T)
        </li>
      </ul>
      <ul>
        <li @click="handleOutEnter('enter')"><i class="icon icon-ruchang1" style="color:#07AD32" />手动入场(V)</li>
        <li @click="handleOutEnter('out')"><i class="icon icon-chuchang" style="color:#0BA4DD" />手动出场(B)</li>
        <li @click="handleOutAndEnterRecord('bepresent')"><i class="icon icon-jidongchechang"
            style="color:#DE5A1F" />在场车辆(N)</li>
        <li @click="handleCarInfo"><i class="icon icon-gantanhaozhong" style="color:#4C1FDE" />车辆信息(M)</li>
      </ul>
      <ul>
        <li @click="$refs.dialogHandover.init"><i class="icon icon-jiaohuan" style="color:#981EFF" />交班(K)</li>
        <li @click="handleLock"><i class="icon icon-taocan-suoxiao" style="color:#984D11" />锁屏(L)</li>
      </ul>
    </div>
    <dialogSentry ref="dialogSentry" title="请选择值班岗亭" :close="false" @confirm="confirmSentry" />

    <dialogLock ref="dialogLock" title="解锁" :close="false" @confirm="confirmLock" />
    <dialogOutEnter ref="dialogOutEnter" :title="outEnterTitle" :freeOutList="freeOutList"
      @upInRecord="handleOutAndEnterRecord('bepresent')" />
    <dialogOutEnterRecord ref="dialogOutEnterRecord" :title="outEnterTitle" @appearance="appearance" />
    <dialogProhibitRecord ref="dialogProhibitRecord" />
    <dialogUnpayRecord ref="dialogUnpayRecord" />
    <dialogCarInfo ref="dialogCarInfo" />
    <dialogHandover ref="dialogHandover" />
    <dialogBilling ref="dialogBilling" title="计费详情" />
    <PreviewImg ref="PreviewImg" />
    <Intercom v-if="JSON.stringify(gateData).includes('dh') || JSON.stringify(gateData).includes('cyb')"
      ref="intercomRef" @callingAccept="handleCallingAccept" />
    <Shy v-if="JSON.stringify(gateData).includes('shy')" ref="shyRef" @callingAccept="handleCallingAccept" />

  </div>
</template>

<script>
import dialogSentry from '@/views/login/dialog-sentry'
import dialogLock from '@/views/login/dialog-lock'
import dialogOutEnter from '@/views/admin/dialog-out-enter'
import dialogOutEnterRecord from '@/views/admin/dialog-out-enter-record'
import dialogProhibitRecord from '@/views/admin/dialog-prohibit-record'
import dialogUnpayRecord from '@/views/admin/dialog-unpay-record'
import dialogCarInfo from '@/views/admin/dialog-car-info'
import dialogHandover from '@/views/admin/dialog-handover'
import dialogBilling from '@/views/admin/dialog-billing'
import PreviewImg from '@/components/PreviewImg'
import Intercom from '@/views/intercom/index'
import Shy from './intercom/shy.vue'

import * as API_index from "@/api/index";
import * as API_login from "@/api/login";
import { setTimeout } from 'timers';
import axios from 'axios'
import store from '@/store'
import '@/utils/mqttws31'
import JSEncrypt from '@/static/js/jsencrypt.min.js'
let Base64 = require('js-base64').Base64
import lmd5 from '@/utils/lmd5'
export default {
  name: 'Home',
  components: {
    dialogSentry,
    dialogLock,
    dialogOutEnter,
    dialogOutEnterRecord,
    dialogProhibitRecord,
    dialogUnpayRecord,
    dialogCarInfo,
    dialogHandover,
    dialogBilling,
    PreviewImg,
    Intercom,
    Shy
  },
  data() {
    return {
      timer: '', //定时器
      loading: true,
      user: {},
      park_id: this.getStore('park_id'),
      sentry_id: this.getStore('sentry_id'),
      gateData: [],
      pendingList: [], //待处理车辆记录
      pendingNum: 0,
      remainData: {}, //现场车辆统计数据
      recordsEntData: {}, //入口现场车辆信息
      recordsDepData: {
        extra: {}
      }, //出场现场车辆信息
      prePayLoading: false, //现金放行状态
      disposeLoading: false, //不予处理状态
      freeDirectionLoading: false, //开闸放行
      freeOutLoading: false, //免费放行状态
      freeOutList: [], //免费放行原因列表
      freeOut: '', //免费放行原因
      lockState: false, //锁屏状态
      isFullScreen: false, //是否全屏
      outEnterTitle: '',//弹窗名
      subTopic: "/vel/receive/", //订阅主题
      pubTopic: "/vel/info", //发布主题
      recognizeLoading: false, //手动触发识别
      openAndCloseLoading: false, //开闸关闸状态
      dialogVisibleLookup: false,//快捷入口状态
      isFirefox: navigator.userAgent.includes('Firefox'), //是否火狐
      decrypt: new JSEncrypt(),
      prop_rule_id: '', //计费规则id
      ruleList: [], //计费规则列表
      intercom: '', //呼叫对讲数据
      mqttReconnectAttempts: 0, //MQTT重连尝试次数
      maxMqttReconnectAttempts: 5, //最大重连次数
      mqttReconnectTimer: null, //MQTT重连定时器
      isConnecting: false, //是否正在连接中
      carouselHeight: '600px', //视频轮播高度（随窗口自适应）
    }
  },
  created() {
    document.addEventListener('keydown', this.keydown, false)
    console.info(" park_id  =====>>>> 2", this.park_id)
    console.info(" sentry_id  =====>>>> ", this.sentry_id)
    this.user = JSON.parse(this.getStore('user')).user
    // this.subTopic = this.subTopic + this.park_id
    // if (this.hasSentry()) {
    //   console.info(" sentry_id  =====>>>> ", this.sentry_id)
    //   this.subTopic = this.subTopic + '/' + this.sentry_id;
    // } else {
    //   this.subTopic = this.subTopic + "/#"
    // }
    this.decrypt.setPrivateKey(process.env.VUE_APP_RASKEY)

  },
  mounted() {
    this.init()
    this.initMqttConnection();
    this.setCarouselHeight()
    window.addEventListener('resize', this.setCarouselHeight)
    window.addEventListener('beforeunload', () => {
      this.disConnect();
    });
  },
  watch: {
    pendingList(newList) {
      if (newList) {
        let num = 0
        for (let i in newList) {
          if (newList[i].gate_id == this.recordsDepData.gate_id || newList[i].car_number == this.recordsDepData.car_number) {
            num++
          }
        }
        this.pendingNum = newList.length - num
      }
    }
  },
  beforeUnmount() {
    clearInterval(this.timer);
    if (this.mqttReconnectTimer) {
      clearTimeout(this.mqttReconnectTimer);
    }
    window.removeEventListener('resize', this.setCarouselHeight)
    this.disConnect();
    document.removeEventListener('keydown', this.keydown, false)

  },
  methods: {
    // 根据窗口高度计算视频轮播区域高度（顶部栏60 + 底部栏50 + 上下留白30 + 指示器30）
    setCarouselHeight() {
      const height = window.innerHeight - 170
      this.carouselHeight = Math.max(320, height) + 'px'
    },
    // 刷新页面，重新加载视频与推送数据
    handleRefresh() {
      location.reload()
    },
    // 验证MQTT配置是否完整
    validateMqttConfig() {
      const mqtt = store.state.mqtt;
      if (!mqtt) {
        console.warn('[MQTT] 配置不存在');
        return false;
      }
      const requiredFields = ['mqtt_url', 'mqtt_user', 'mqtt_pwd', 'mqtt_recv_topics', 'mqtt_send_topic'];
      for (let field of requiredFields) {
        if (!mqtt[field]) {
          console.warn(`[MQTT] 缺少必需字段: ${field}`);
          return false;
        }
      }
      return true;
    },

    // 初始化MQTT连接
    async initMqttConnection() {
      if (this.validateMqttConfig()) {
        this.subTopic = store.state.mqtt.mqtt_recv_topics.split(';')[0];
        this.pubTopic = store.state.mqtt.mqtt_send_topic;
        await this.MQTTConnect();
        if (store.state.mqtt.mqtt_keep_live) {
          this.timer = setInterval(this.heartBeat, store.state.mqtt.mqtt_keep_live * 1000);
        }
      } else {
        console.warn('[MQTT] 配置不完整，尝试重新获取配置...');
        await this.reconnectMqtt();
      }
    },

    // 重新获取MQTT配置并连接
    async reconnectMqtt() {
      if (this.mqttReconnectAttempts >= this.maxMqttReconnectAttempts) {
        console.error('[MQTT] 已达到最大重连次数，停止重连');
        this.$message.error('MQTT连接失败，请刷新页面重试');
        return;
      }

      if (this.isConnecting) {
        console.log('[MQTT] 正在连接中，跳过本次重连');
        return;
      }

      this.mqttReconnectAttempts++;
      console.log(`[MQTT] 尝试重新连接 (${this.mqttReconnectAttempts}/${this.maxMqttReconnectAttempts})...`);

      try {
        this.isConnecting = true;
        await store.dispatch('getMqtt', {
          park_id: this.getStore('park_id'),
          sentry_id: this.getStore('sentry_id')
        });

        if (this.validateMqttConfig()) {
          this.subTopic = store.state.mqtt.mqtt_recv_topics.split(';')[0];
          this.pubTopic = store.state.mqtt.mqtt_send_topic;
          await this.MQTTConnect();
          if (store.state.mqtt.mqtt_keep_live) {
            this.timer = setInterval(this.heartBeat, store.state.mqtt.mqtt_keep_live * 1000);
          }
          this.mqttReconnectAttempts = 0; // 重置重连次数
          console.log('[MQTT] 连接成功');
        } else {
          throw new Error('MQTT配置验证失败');
        }
      } catch (error) {
        console.error('[MQTT] 重连失败:', error);
        // 5秒后再次尝试
        this.mqttReconnectTimer = setTimeout(() => {
          this.isConnecting = false;
          this.reconnectMqtt();
        }, 5000);
      } finally {
        this.isConnecting = false;
      }
    },

    // 检查是否应该禁用快捷键
    shouldDisableShortcuts() {
      try {
        // 1. 检查 Element UI Dialog 遮罩层（弹窗打开时 body 会有这个 class）
        if (document.body.classList.contains('el-popup-parent--hidden')) {
          console.log('[快捷键] Element UI 弹窗已打开，禁用快捷键');
          return true;
        }

        // 2. 检查 Element UI 的遮罩层（通用）- 检查 display 是否为 block
        const overlays = document.querySelectorAll('.el-overlay');
        for (let overlay of overlays) {
          // 检查内联样式
          if (overlay.style.display === 'block') {
            console.log('[快捷键] Element UI 遮罩层已打开（内联样式），禁用快捷键');
            return true;
          }
          // 检查计算样式
          const computedStyle = window.getComputedStyle(overlay);
          if (computedStyle.display === 'block') {
            console.log('[快捷键] Element UI 遮罩层已打开（计算样式），禁用快捷键');
            return true;
          }
        }

        // 3. 检查 Element UI 图片预览遮罩层
        const imageViewer = document.querySelector('.el-image-viewer__mask');
        if (imageViewer) {
          const viewerStyle = window.getComputedStyle(imageViewer);
          if (viewerStyle.display !== 'none') {
            console.log('[快捷键] 图片预览已打开，禁用快捷键');
            return true;
          }
        }

        // 4. 检查输入框是否获得焦点
        const activeElement = document.activeElement;
        if (activeElement) {
          // 检查是否是 input 或 textarea
          if (activeElement.tagName === 'INPUT' ||
            activeElement.tagName === 'TEXTAREA' ||
            activeElement.contentEditable === 'true') {
            console.log('[快捷键] 输入框已获得焦点，禁用快捷键');
            return true;
          }

          // 检查 Element UI 的输入框
          if (activeElement.classList.contains('el-input__inner')) {
            console.log('[快捷键] Element UI 输入框已获得焦点，禁用快捷键');
            return true;
          }

          // 检查旧版逻辑：el-input--suffix is-focus
          const suffixInputs = document.getElementsByClassName('el-input--suffix');
          if (suffixInputs.length > 0) {
            const firstSuffixInput = suffixInputs[0];
            if (firstSuffixInput.classList.contains('is-focus')) {
              console.log('[快捷键] Element UI 输入框（旧版）已获得焦点，禁用快捷键');
              return true;
            }
          }
        }

        // 5. 检查其他常见弹窗/下拉框
        // Select 下拉框
        const selectDropdown = document.querySelector('.el-select-dropdown');
        if (selectDropdown) {
          const dropdownStyle = window.getComputedStyle(selectDropdown);
          if (dropdownStyle.display !== 'none' && selectDropdown.offsetParent !== null) {
            console.log('[快捷键] Select 下拉框已打开，禁用快捷键');
            return true;
          }
        }

        // DatePicker 日期选择器
        const datePicker = document.querySelector('.el-picker-panel');
        if (datePicker) {
          const pickerStyle = window.getComputedStyle(datePicker);
          if (pickerStyle.display !== 'none' && datePicker.offsetParent !== null) {
            console.log('[快捷键] 日期选择器已打开，禁用快捷键');
            return true;
          }
        }

        // Message 消息提示
        const messageBox = document.querySelector('.el-message-box__wrapper');
        if (messageBox) {
          const boxStyle = window.getComputedStyle(messageBox);
          if (boxStyle.display !== 'none' && messageBox.offsetParent !== null) {
            console.log('[快捷键] Message 消息框已打开，禁用快捷键');
            return true;
          }
        }

        return false;
      } catch (error) {
        console.error('[快捷键] 检查时出错:', error);
        return false; // 出错时不禁用，保证可用性
      }
    },

    keydown(e) {
      // 检查是否应该禁用快捷键
      if (this.shouldDisableShortcuts()) {
        return false
      }
      if (e.code == 'KeyR') {
        if (this.recordsEntData.memo) {
          this.handleQuick()
        }
      } else if (e.code == 'KeyU') {
        if (this.recordsDepData.pay_price > 0) {
          this.handlePrePay(this.recordsDepData)
        }
      } else if (e.code == 'KeyI') {
        console.log('I')
      } else if (e.code == 'KeyP') {
        if (this.recordsDepData.pay_price > 0) {
          this.handleFreeOut(this.recordsDepData)
        }
      } else if (e.code == 'KeyZ') {
        this.handleOutAndEnterRecord('enter')
      } else if (e.code == 'KeyX') {
        this.handleOutAndEnterRecord('out')
      } else if (e.code == 'KeyC') {
        this.handleProhibitRecord()
      } else if (e.code == 'KeyT') {
        this.handleUnpayRecord()
      } else if (e.code == 'KeyV') {
        this.handleOutEnter('enter')
      } else if (e.code == 'KeyB') {
        this.handleOutEnter('out')
      } else if (e.code == 'KeyN') {
        this.handleOutAndEnterRecord('bepresent')
      } else if (e.code == 'KeyM') {
        this.handleCarInfo()
      } else if (e.code == 'KeyK') {
        this.$refs.dialogHandover.init()
      } else if (e.code == 'KeyL') {
        this.handleLock()
      }
    },
    MQTTConnect() {
      try {
        // 验证配置
        if (!this.validateMqttConfig()) {
          throw new Error('MQTT配置不完整');
        }

        sessionStorage.setItem('new', true);
        console.log('[MQTT] 开始连接...', store.state.mqtt);

        // 解密并解析URL
        let decryptedUrl;
        let host;
        let port;

        try {
          decryptedUrl = this.decrypt.decrypt(store.state.mqtt.mqtt_url);
          if (!decryptedUrl) {
            throw new Error('URL解密失败');
          }

          // 解析host和port
          const urlParts = decryptedUrl.split('//')[1]?.split('/')[0]?.split(':');
          if (!urlParts || urlParts.length < 2) {
            throw new Error('URL格式错误: ' + decryptedUrl);
          }

          host = urlParts[0];
          port = parseInt(urlParts[1]);

          if (!host || isNaN(port)) {
            throw new Error(`Host或Port解析失败: host=${host}, port=${port}`);
          }

          console.log(`[MQTT] 连接参数: host=${host}, port=${port}`);
        } catch (error) {
          console.error('[MQTT] URL解析错误:', error);
          throw error;
        }

        // 创建MQTT客户端
        this.mqtt = new Paho.MQTT.Client(
          host,
          port,
          "pc-client-" + this.user.id
        );

        const options = {
          timeout: 10,
          useSSL: false,
          cleanSession: true,
          onSuccess: this.onConnect,
          onFailure: (error) => {
            console.error('[MQTT] 连接失败:', error);
            this.$message.warning(`MQTT连接失败: ${error.errorMessage || '未知错误'}`);
            // 连接失败后尝试重连
            this.isConnecting = false;
            if (this.mqttReconnectAttempts < this.maxMqttReconnectAttempts) {
              setTimeout(() => this.reconnectMqtt(), 5000);
            }
          },
          keepAliveInterval: 60,
          reconnect: true,
        };

        this.mqtt.onConnectionLost = this.onConnectionLost;
        this.mqtt.onMessageArrived = this.onMessageArrived;

        // 设置用户名和密码
        try {
          const decryptedUser = this.decrypt.decrypt(store.state.mqtt.mqtt_user);
          const decryptedPwd = this.decrypt.decrypt(store.state.mqtt.mqtt_pwd);

          if (decryptedUser) {
            options.userName = decryptedUser;
          }
          if (decryptedPwd) {
            options.password = decryptedPwd;
          }

          console.log('[MQTT] 认证信息已设置');
        } catch (error) {
          console.error('[MQTT] 解密认证信息失败:', error);
          throw new Error('认证信息解密失败');
        }

        // 开始连接
        console.log('[MQTT] 正在建立连接...');
        this.mqtt.connect(options);

      } catch (error) {
        console.error('[MQTT] 初始化错误:', error);
        this.isConnecting = false;
        this.$message.error(`MQTT初始化失败: ${error.message}`);

        // 尝试重新获取配置
        if (this.mqttReconnectAttempts < this.maxMqttReconnectAttempts) {
          setTimeout(() => this.reconnectMqtt(), 5000);
        }
      }
    },
    //uuid随机生成
    getUuid() {
      var uid = [];
      var hexDigits = "0123456789abcdefghijklmnopqrst";
      for (var i = 0; i < 32; i++) {
        uid[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      uid[6] = "4";
      uid[15] = hexDigits.substr((uid[15] & 0x3) | 0x8, 1);
      var uuid = uid.join("");
      return uuid;
    },
    //连接
    onConnect() {
      console.log("[MQTT] 连接成功!");
      // 重置重连计数器
      this.mqttReconnectAttempts = 0;
      this.isConnecting = false;

      // 连接成功，订阅信息
      console.log("[MQTT] 订阅主题: " + this.subTopic, this.mqtt);
      const dataList = store.state.mqtt.mqtt_recv_topics.split(';')
      for (let i in dataList) {
        this.mqtt.subscribe(dataList[i]);
        console.log(`[MQTT] 已订阅: ${dataList[i]}`);
      }

      // 获取初始化数据(包含余位信息，最新的进出口信息)
      this.getParkInitData();
    },

    //主动断开连接
    disConnect() {
      console.log("[MQTT] 断开连接");
      if (this.mqttReconnectTimer) {
        clearTimeout(this.mqttReconnectTimer);
        this.mqttReconnectTimer = null;
      }
      if (this.mqtt && this.mqtt.isConnected()) {
        try {
          this.mqtt.disconnect();
        } catch (error) {
          console.error('[MQTT] 断开连接时出错:', error);
        }
      } else {
        console.log('[MQTT] 客户端未连接或不存在');
      }
    },



    //发送mqtt消息
    sendMqttReq(params) {
      this.mqtt.send(this.pubTopic, JSON.stringify(params), 0);
    },

    //获取余位数据
    getParkRemain() {
      const date = new Date().getTime()
      let remain = {
        pkg_id: this.mqtt.clientId,
        pkg_type: 'REQ',
        cmd: 'motor_remain_notify',
        bus_type: store.state.mqtt.mqtt_recv_topics.split('/')[1],
        client_type: store.state.mqtt.mqtt_client_id.split('-')[0],
        client_id: store.state.mqtt.mqtt_client_id.split('-').pop(),
        timestamp: date,
        version: '1.0',
        sign: this.getSign(date),
        data: {
          "oper_id": store.state.mqtt.mqtt_client_id.split('-')[1],
          "sp_id": store.state.mqtt.mqtt_client_id.split('-')[2],
          "merc_id": store.state.mqtt.mqtt_client_id.split('-')[3],
          "prop_id": store.state.mqtt.mqtt_client_id.split('-')[4],
          "park_id": store.state.mqtt.mqtt_client_id.split('-')[5],
          "sentry_id": store.state.mqtt.mqtt_client_id.split('-')[6] || 0
        },
      }
      // if (this.hasSentry()) {
      //   remain['bizContent']['sentry_id'] = this.sentry_id
      // }
      this.sendMqttReq(remain);
      // let remain = {
      //   "cmd": 1,
      //   "bizContent": {
      //     "park_id": this.park_id,
      //   },
      // }
      // if (this.hasSentry()) {
      //   remain['bizContent']['sentry_id'] = this.sentry_id
      // }
      // this.sendMqttReq(remain);
    },
    getSign(date) {
      // bus_type, client_id, client_type, cmd, pkg_id, pkg_type, timestamp, version
      const sign = store.state.mqtt.mqtt_recv_topics.split('/')[1] + store.state.mqtt.mqtt_client_id.split('-').pop() + store.state.mqtt.mqtt_client_id.split('-')[0] + 'gateway_heart_beat' + this.mqtt.clientId + 'REQ' + date + '1.0'
      return lmd5.hex_md5(sign)
    },
    //获取初始化数据
    getParkInitData() {
      const date = new Date().getTime()
      let remain = {
        pkg_id: this.mqtt.clientId,
        pkg_type: 'REQ',
        cmd: 'motor_init_data',
        bus_type: store.state.mqtt.mqtt_recv_topics.split('/')[1],
        client_type: store.state.mqtt.mqtt_client_id.split('-')[0],
        client_id: store.state.mqtt.mqtt_client_id.split('-').pop(),
        timestamp: date,
        version: '1.0',
        sign: this.getSign(date),
        data: {
          "oper_id": store.state.mqtt.mqtt_client_id.split('-')[1],
          "sp_id": store.state.mqtt.mqtt_client_id.split('-')[2],
          "merc_id": store.state.mqtt.mqtt_client_id.split('-')[3],
          "prop_id": store.state.mqtt.mqtt_client_id.split('-')[4],
          "park_id": store.state.mqtt.mqtt_client_id.split('-')[5],
          "sentry_id": store.state.mqtt.mqtt_client_id.split('-')[6] || 0
        },
      }
      // if (this.hasSentry()) {
      //   remain['bizContent']['sentry_id'] = this.sentry_id
      // }
      this.sendMqttReq(remain);
    },

    hasSentry() {
      return null != this.sentry_id && this.sentry_id.length > 0
    },

    heartBeat() { //发送心跳包
      const date = new Date().getTime()
      let remain = {
        pkg_id: this.mqtt.clientId,
        pkg_type: 'REQ',
        cmd: 'gateway_heart_beat',
        bus_type: store.state.mqtt.mqtt_recv_topics.split('/')[1],
        client_type: store.state.mqtt.mqtt_client_id.split('-')[0],
        client_id: store.state.mqtt.mqtt_client_id.split('-').pop(),
        timestamp: date,
        version: '1.0',
        sign: this.getSign(date),
        data: {
          "oper_id": store.state.mqtt.mqtt_client_id.split('-')[1],
          "sp_id": store.state.mqtt.mqtt_client_id.split('-')[2],
          "merc_id": store.state.mqtt.mqtt_client_id.split('-')[3],
          "prop_id": store.state.mqtt.mqtt_client_id.split('-')[4],
          "park_id": store.state.mqtt.mqtt_client_id.split('-')[5],
          "sentry_id": store.state.mqtt.mqtt_client_id.split('-')[6] || 0
        },
      }
      // let remain = {
      //   "cmd": 9,
      //   "bizContent": {
      //     "park_id": this.park_id,
      //   },
      // }
      // if (this.hasSentry()) {
      //   remain['bizContent']['sentry_id'] = this.sentry_id
      // }
      this.sendMqttReq(remain);
    },
    // 接听挂断推送
    handleCallingAccept(data, talk_status) {
      const date = new Date().getTime()
      const clientIdParts = store.state.mqtt.mqtt_client_id.split('-')
      const remain = {
        pkg_id: this.mqtt.clientId,
        pkg_type: 'REQ',
        cmd: 'service_talk_notify',
        bus_type: store.state.mqtt.mqtt_recv_topics.split('/')[1],
        client_type: clientIdParts[0],
        client_id: clientIdParts.pop(),
        timestamp: date,
        version: '1.0',
        sign: this.getSign(date),
        data: {
          "oper_id": clientIdParts[1],
          "sp_id": clientIdParts[2],
          "merc_id": clientIdParts[3],
          "prop_id": clientIdParts[4],
          "park_id": clientIdParts[5],
          "sentry_id": clientIdParts[6] || 0,
          "user_id": localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).user.id : null,
          "gate_id": data.gate_id,
          "center_id": data.device_id || data.talkback_device_id || data.cid,
          "device_sn": data.device_sn || data.talkback_device_no || data.sn,
          "device_type": 6,
          "device_model": data.device_model || data.talkback_device_model_name,
          "talk_status": talk_status,
        },
      }
      console.log('接听挂断推送', remain)
      this.sendMqttReq(remain);
    },

    //连接丢失
    onConnectionLost(response) { //链接丢失，需要重连
      console.log("[MQTT] 连接断开:", response.errorCode, response.errorMessage);

      // AMQJS0008I 表示客户端主动断开
      if (response.errorMessage.includes('AMQJS0008I')) {
        if (sessionStorage.getItem('new')) {
          console.log('[MQTT] 检测到页面刷新，关闭窗口');
          window.location.href = "about:blank";
        } else {
          console.log('[MQTT] 尝试重新连接...');
          this.MQTTConnect();
        }
      } else {
        // 其他原因导致的断开，尝试重连
        console.warn('[MQTT] 异常断开，将在5秒后重连...');
        if (!localStorage.getItem('token')) {
          return
        }
        this.isConnecting = false;
        if (this.mqttReconnectAttempts < this.maxMqttReconnectAttempts) {
          setTimeout(() => this.reconnectMqtt(), 5000);
        } else {
          this.$message.error('MQTT连接已断开，请刷新页面重试');
        }
      }
    },
    //接收到消息，处理
    onMessageArrived(message) {
      // var topics = message.destinationName;
      var msg = message.payloadString;
      // let packData = JSON.parse(msg);
      // console.log(" mqtt receive  packData 1 " + packData)

      //判断主题，调用方法，这里可以订阅多个主题，在此处判断，接受不同的主题，调用不同的方法！
      // if (topics == this.subTopic) {
      let packData = JSON.parse(msg);
      console.log(" mqtt receive  ", packData)

      /**
       * 返回结构
       *  {
       *    "code":0，//0 成功，非0表示异常
       *    "msg":"请求成功",
       *    "cmd":0, //对应的协议头
       *    "data":0, //具体的数据
       *  }
       */

      switch (packData.cmd) {
        case 'motor_init_data': //初始化数据的包
          //{"msg":"请求成功","code":0,"data":{"records":{"ent":{"type_name":"临停","dep_pic":"https://parking-lots.oss-cn-hangzhou.aliyuncs.com/picture/0/c2554891-157a60d9/20220303/14/20220303_145432_874.jpg","ent_time":"2022-03-03 14:33:55","ent_state":"否","created_at":"2022-03-03 14:33:55","type":0,"prop_user_id":0,"dep_state":"否","updated_at":"2022-03-03 14:54:33","dep_gate_id":0,"id":2736,"state":1,"car_id":0,"prop_id":2,"dep_time":0,"park_id":17,"ent_gate_id":20,"ent_pic":"https://parking-lots.oss-cn-hangzhou.aliyuncs.com/picture/0/e2b5b8f6-ce1ac5ad/20220303/14/20220303_143354_201.jpg","timing_state":"否","record_id":2736,"garage_id":0,"user_id":198,"ent_gate_name":"A通道-入口","car_number":"闽DL167M","pay_id":0,"car_size_type":1},"dep":{"type_name":"临停","dep_pic":"https://parking-lots.oss-cn-hangzhou.aliyuncs.com/picture/0/c2554891-157a60d9/20220303/14/20220303_143343_058.jpg","ent_time":"2022-03-03 14:33:43","ent_state":"否","dep_gate_name":"A通道-出口","memo":"无入场补录","created_at":"2022-03-03 14:33:43","type":0,"prop_user_id":0,"dep_state":"否","updated_at":"2022-03-03 14:33:43","dep_gate_id":21,"price":0,"id":2735,"state":4,"car_id":0,"aly_pay_price":0,"pay_price":0,"prop_id":0,"dep_time":"2022-03-03 14:33:43","park_id":17,"ent_gate_id":-1,"ent_pic":"https://parking-lots.oss-cn-hangzhou.aliyuncs.com/picture/0/c2554891-157a60d9/20220303/14/20220303_143343_058.jpg","timing_state":"否","record_id":2735,"garage_id":0,"user_id":0,"ent_gate_name":"","car_number":"无牌车","pay_id":0,"car_size_type":1}},"remain":{"left":3,"list":[{"name":"临时车","count":5},{"name":"月租车","count":1},{"name":"其他车","count":1}]}},"cmd":1}
          console.info(" mqtt receive  初始化数据推送 ", packData.data)
          this.remainData = packData.data.remain
          this.recordsEntData = packData.data.records.ent
          this.recordsDepData = packData.data.records.dep
          this.recordsDepData.gate_id = this.recordsDepData.dep_gate_id
          //this.prop_rule_id = Number(this.recordsDepData.rule_id)
          this.getUnpay(this.recordsDepData, true)
          break;
        case 'motor_remain_notify': //余位信息推送
          console.info(" mqtt receive  余位信息推送 ", packData.data)
          this.remainData = packData.data
          break;
        case 'motor_in_notify': //最新的入场车辆推送
          //{"data":{"car_number":"闽D6987A","park_id":17,"gate_id":20,"is_fake":0,"pic":"https://parking-lots.oss-cn-hangzhou.aliyuncs.com/picture/0/e2b5b8f6-ce1ac5ad/20220303/15/20220303_155739_244.jpg","record_time":1646294259,"car_type":"临停"},"cmd":2,"code":0,"msg":""}
          console.info(" mqtt receive  最新的入场车辆推送 ", packData.data)
          this.recordsEntData = Object.assign(packData.data, packData.data.extra)
          break;
        case 'motor_out_notify': //最新的出场车辆推送
          /**
           *{"data":{"car_number":"闽D6987A","park_id":17,"gate_id":21,"is_fake":0,"pic":"https://parking-lots.oss-cn-hangzhou.aliyuncs.com/picture/0/c2554891-157a60d9/20220303/15/20220303_155829_085.jpg","record_time":1646294309,"car_type":"临停","extra":{"aly_pay_price":0.0,"pay_price":0.0,"price":0.0,"ent_time":"2022-03-03 15:57:39","park_time":""}},"cmd":3,"code":0,"msg":""}
           */
          console.info(2222, " mqtt receive  最新的出场车辆推送 ", packData.data, packData.data.extra.aly_pay_price)
          // 同个通道和同个车牌号和待支付金额为0时 顶掉页面数据
          if (this.recordsDepData.gate_id == packData.data.gate_id || this.recordsDepData.car_number == packData.data.car_number || this.recordsDepData.pay_price == 0 && packData.pay_price != 0) {
            if (this.recordsDepData.car_number == packData.data.car_number && this.recordsDepData.aly_pay_price > packData.data.extra.aly_pay_price) {
              packData.data.extra.aly_pay_price = this.recordsDepData.aly_pay_price
              packData.data.extra.pay_price = this.recordsDepData.pay_price
            }
            this.recordsDepData = Object.assign(packData.data, packData.data.extra)
            // this.prop_rule_id = Number(this.recordsDepData.rule_id)
          }
          this.getUnpay(Object.assign(packData.data, packData.data.extra), true)
          break;
        case 'motor_pay_notify': //支付成功通知
          console.info(" mqtt receive  支付成功通知 ", packData.data)
          this.recordsDepData = packData.data
          // this.MQTTConnect();
          this.getUnpay(Object.assign(packData.data, packData.data.extra), false)
          break;
        case 'gateway_heart_beat': //心跳包
          console.info(" mqtt receive 心跳包 ", packData.data)
          break;
        case 'motor_talk_notify': //对讲呼叫
          console.info(" mqtt receive 对讲呼叫 ", packData.data)
          this.intercom = packData.data

          for (let i in this.gateData) {
            if (this.gateData[i].id == this.intercom.gate_id && ['shy'].includes(this.intercom.device_model) && this.intercom.talk_status == 1) {
              this.$refs.shyRef.open('[' + this.gateData[i].type + ']' + this.gateData[i].name, this.gateData[i].talkback)
            } else if (this.gateData[i].id == this.intercom.gate_id && this.intercom.talk_status == 1) {
              this.$refs.intercomRef.open('[' + this.gateData[i].type + ']' + this.gateData[i].name, this.intercom)
            }
          }
          break;

      }
      //添加
      // this.color = msg
      // }
      // else {
      //   return;
      // }
    },
    init() {
      if (this.getStore('lockState')) {
        this.lockState = this.getStore('lockState')
        this.$refs.dialogLock.init()
        return false
      }
      if (this.getStore('sentryState')) {
        this.$refs.dialogSentry.init()
        return false
      }
      this.getGate()
      this.getFreeOutList()
      // this.getUnpay()
      this.getRuleList()
    },
    getRuleList() {
      API_index.getParkPropRule({ park_id: this.park_id, type: 1 }).then(res => {
        this.ruleList = res
        this.prop_rule_id = Number(this.ruleList[0].id)
      })
    },
    getGate() {
      let form = {
        park_id: this.park_id,
        sentry_id: this.getStore('sentry_id')
      }
      API_index.getParkGate(form).then(res => {
        this.loading = false
        this.gateData = res
        this.$nextTick(async () => {
          for (let i in this.gateData) {
            // 跨域时 播放失败
            this.gateData[i].device.flvfail = false
            // if (this.gateData[i].device && this.gateData[i].device.model_name == 'qy') {
            //   this.gateData[i].device.local_addr = `http://${this.gateData[i].device.local_addr}:8088/cgi-bin/video_cgi`
            // }
            if (this.gateData[i].device && (this.gateData[i].device.model_name == 'qy' || this.gateData[i].device.model_name == 'hc')) {
              // this.gateData[i].device.rtsp_url = 'rtsp://avd.qsparking.com:7554/live?device=16&channel=1&stream=0'
              await this.setRtsp(this.gateData[i].device, i)
              this.gateData[i].device.rtspFun.play(this.gateData[i].device.rtsp_url)
            } else if (this.gateData[i].device && this.gateData[i].device.model_name == 'ice') {
              let ws = null;
              let imgUrl = 'ws:' + this.gateData[i].device.local_addr + ':9999'
              ws = new WebSocket(imgUrl);
              ws.onopen = () => {
                console.log("open...");
              }
              let img = new Image();
              img.onload = () => {
                this.$refs['iceRef' + this.gateData[i].device.id].src = img.src;
              }
              ws.onmessage = (event) => {
                if (typeof (event.data) == "string") { //字符串数据
                  // var result = JSON.parse(event.data);
                } else {//视频图片流数据  
                  let reader = new FileReader();
                  reader.readAsDataURL(event.data);
                  reader.onload = (evn) => {
                    img.src = evn.target.result;
                  };
                }
              };
              ws.onerror = () => {
                console.log("error");
              }
              ws.onclose = () => {
                console.log("close");
              }
            } else if (this.gateData[i].device && this.gateData[i].device.model_name == 'xlt') {
              // this.xltPlayFlv(this.gateData[i], i)
              var showOperateBtns = true; // 是否显示按钮
              var forceNoOffscreen = true; //
              let jessibuca = new Jessibuca({
                container: document.getElementById('xlt' + this.gateData[i].device.id + i),
                videoBuffer: 0.2, // 缓存时长
                isResize: true, // 容器尺寸变化时播放器自适应
                text: "",
                loadingText: "加载中",
                debug: true,
                showBandwidth: showOperateBtns, // 显示网速
                operateBtns: {
                  fullscreen: showOperateBtns,
                  screenshot: showOperateBtns,
                  play: showOperateBtns,
                  audio: showOperateBtns,
                },
                forceNoOffscreen: forceNoOffscreen,
                isNotMute: false,
                isFlv: true,
              },);
              // jessibuca.onLog = msg => console.error(msg);
              // jessibuca.onRecord = (status) => console.log('onRecord', status);
              // jessibuca.onPause = () => console.log('onPause');
              // jessibuca.onPlay = () => console.log('onPlay');
              // jessibuca.onFullscreen = msg => console.log('onFullscreen', msg);
              // jessibuca.onMute = msg => console.log('onMute', msg);
              jessibuca.play('ws://' + this.gateData[i].device.local_addr + ':9953&flv_protocol')
            } else if (this.gateData[i].device && this.gateData[i].device.model_name == 'sj') {
              this.sjPlayFlv(this.gateData[i], i)
            } else if (this.gateData[i].device && this.gateData[i].device.local_addr.includes('.flv')) {
              this.playFlv(this.gateData[i], i)
            } else if (this.gateData[i].device && this.gateData[i].device.local_addr.includes('.m3u8')) {
              this.play(this.gateData[i].id, i)
            } else if (this.gateData[i].device && this.gateData[i].device.local_addr.includes('.php')) {
              this.getMqttFlv(this.gateData[i], i)
            } else if (this.gateData[i].device && this.gateData[i].device.local_addr) {
              this.getHttp(this.gateData[i], i)
            }
          }
        });
      })

    },
    getMqttFlv(data, i) {
      axios({
        method: 'post',
        url: data.device.local_addr,
        data: {
          type: 'get_live_stream_type',
          module: 'BUS_WEB_REQUEST'
        },
        headers: {
          // 'Access-Control-Allow-Origin': '*'
        },
      }).then((res) => {
        if (res.status == 200) {
          var pubkey = Base64.decode(res.data.body.pubkey)
          let encryptStr = new JSEncrypt()
          encryptStr.setPublicKey(pubkey)
          var str = 'admin:admin'
          var token = encodeURIComponent(encryptStr.encrypt(str.toString()))
          data.device.local_addr = 'ws://' + data.device.local_addr.split(':')[1].split('/').pop() + ':' + res.data.body.port + '/ws.flv?token=' + token
          data.device.flvfail = false
          this.playFlv(data, i)
        }
      }).catch(() => {
        data.device.flvfail = true
      });
    },
    getHttp(data) {
      //链接服务端
      let ws = new WebSocket("ws://" + data.device.local_addr + ":9080/ws");

      //配置客户端连接成功的回调方法
      ws.onopen = function () {
        console.log("open...");
        ws.send({
          type: "login",
          module: "BUS_WEB_REQUEST",
          user_info: "iotCXVNTU1OUr7Eiif3i/C7/tg=="
        });
        ws.send({
          type: "reg_live_mjpeg",
          module: "BUS_WEB_REQUEST"
        });
      };

      //配置客户端处理消息的回调方法
      ws.onmessage = function (event) {
        let img_1 = new Image();
        img_1.onload = function () {
          data.imageSrc = img_1.src;
        }
        //创建FileReader对象，该对象时html5中的特有对象，详细用法可以//参照html5相关资料
        let reader = new FileReader();

        //设置FileReader对象的读取文件回调方法
        reader.onload = function (eve) {
          //判断文件是否读取完成
          if (eve.target.readyState == FileReader.DONE) {
            //读取文件完成后，创建img标签来显示服务端传来的字节数//组

            //读取文件完成后内容放在this===当前
            //fileReader对象的result属性中，将该内容赋值img标签//浏览器就可以自动解析内容格式并且渲染在浏览器中
            img_1.src = this.result;
            //将标签添加到id为show的div中否则，即便是有img也看不见
            // document.getElementById("show") = img;
          }
        };
        //调用FileReader的readAsDataURL的方法自动就会触发onload事件
        reader.readAsDataURL(event.data);
      };
    },
    getUnpay(data, state) {
      let list = this.getStore('pendingList') && JSON.parse(this.getStore('pendingList')) || []
      if (data.dep_gate_id) {
        data.gate_id = data.dep_gate_id
      }
      let index = list.findIndex(item => (item.gate_id == data.gate_id || item.car_number == data.car_number))
      if (state && index < 0 && data.pay_price > 0) {
        list.push(data)
      } else if (state && index >= 0 && data.pay_price > 0) {
        list[index] = data
      } else if (!state && index >= 0) {
        // this.recordsDepData = list[index]
        this.recordsDepData.pay_price = data.pay_price
        list[index].pay_price = data.pay_price
        // list.splice(index, 1)
        // if (list.length > 0) {
        //   this.recordsDepData = list[0]
        // }
      } else if (!state && this.recordsDepData.car_number == data.car_number) {
        this.recordsDepData.pay_price = data.pay_price
      }
      this.pendingList = list
      this.setStore('pendingList', list)


      // API_index.getRecordUnpay({ park_id: this.park_id }).then(res => {
      //   this.pendingList = res.data
      // })
    },
    play(id, index) {
      console.log(1112, id)
      let myVideo = videojs("myVideo" + id + index, {
        bigPlayButton: true,
        textTrackDisplay: false,
        posterImage: false,
        errorDisplay: false,
        hls: {
          withCredentials: true
        }
      });
      myVideo.children_[0].controls = true
      // console.log(this.myVideo)

    },
    sjPlayFlv(data) {
      data.device.local_addr = `ws://${data.device.local_addr}:8081/live_video0.flv`
      this.playFlv(data)
    },
    xltPlayFlv(data) {
      data.device.local_addr = `ws://${data.device.local_addr}:9953`
      this.playFlv(data)
    },
    playFlv(data) {
      var container = document.getElementById('video' + data.id)
      let player = new window.Jessibuca({ container: container, videoBuffer: 0.2, isResize: true, forceNoOffscreen: true, isNotMute: false, timeout: 10 })
      player.on('load', function () {
        player.play(data.device.local_addr)
      })
      player.on('error', () => {
        // alert("播放错误")
        if (!data.number || data.number < 6) {
          this.playFlv(data)
          data.number = data.number ? data.number + 1 : 1
          return false
        }
        // location.reload();
      })
      player.on('timeout', () => {
        // alert("播放超时")
        if (!data.number || data.number < 6) {
          this.playFlv(data)
          data.number = data.number ? data.number + 1 : 1
          return false
        }
        // location.reload();
      })
      /*
        new window.FlvJsPlayer({
          id: 'video' + data.id,
          isLive: true,
          playsinline: true,
          url: data.device.local_addr,
          autoplay: true,
          autoplayMuted: true,
          width: 370,
          height: 280,
        });
      */
    },
    async setRtsp(data, index) {
      let that = this
      data.rtspFun = await new Rtsp2WPlayer({
        //RTSPtoWebRTC服务器地址
        serverPath: "http://127.0.0.1:8083"// location.protocol + '//' + location.hostname + ':9083'

        //视频容器ID
        , containerId: 'rtsp' + data.id + index

        //是否在控制台输出日志
        , logEnabled: true

        //视频控件样式：HTML元素video的样式
        , style: {
          "controls": true
        }

        /**
         * 当视频连接状态发送变化时的事件回调，如果不关注该事件，可以忽略
         * @param state 连接状态
            connecting:正在连接，connected:连接成功，disconnected：连接断开
         */
        , onconnectionstatechange: function (state) {
          console.log('连接状态：', state);
          if ("disconnected" == state || "failed" == state) {
            data.flvfail = true
            // setTimeout(() => {
            //   console.log('重连...');
            //   this.setRtsp(data, index)
            // }, 5000);
          } else {
            data.flvfail = false
          }
        }
      });
    },
    handleQuick() {
      let form = {
        park_id: this.recordsEntData.park_id,
        gate_id: this.recordsEntData.ent_gate_id || this.recordsEntData.gate_id,
        car_number: this.recordsEntData.car_number,
        actual_open: 1,
        memo: this.recordsEntData.memo,
        ent_time: this.recordsEntData.ent_time,
        pic: this.recordsEntData.ent_pic || this.recordsEntData.pic

      }
      this.dialogVisibleLookup = true
      API_index.postRecordManualIn(form).then(res => {
        this.dialogVisibleLookup = false
        this.recordsEntData.memo = ''
        if (this.type == 'out') {
          this.dialogVisibleInfo = true
          this.carInfo = { ...res.record, ...res.price_info }
        }
      }).catch(() => {
        this.dialogVisibleLookup = false
      })
    },
    getFreeOutList() {
      API_index.getRecordFreeOut({ park_id: this.park_id }).then(res => {
        this.freeOutList = res
        this.freeOut = this.freeOutList[0]
      })
    },
    handleRecognize(e, gate_id) {
      let form = {
        park_id: this.park_id,
        gate_id,
      }
      // this.recognizeLoading = true
      API_index.postGateTrigger(form).then(() => {
        this.recognizeLoading = false
        this.$message({
          type: 'success',
          message: '识别成功!',
        })
      }).catch(() => {
        this.recognizeLoading = false
      })
    },
    handleOpenMode(data) {
      this.$confirm('确认要' + (data.always_open_mode[data.type] == '是' ? '关闭' : '开启') + '吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const form = {
          park_id: this.park_id,
          gate_id: data.id,
          mode: data.always_open_mode[data.type] == '是' ? '否' : '是',
          type: data.type,
        }
        API_index.postGateOpenMode(form).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!',
          })
          data.always_open_mode[data.type] = form.mode
        })
      }).catch(() => { })



    },
    openIntercom(item) {
      if (item.talkback.model_name == 'shy') {
        this.$refs.shyRef.open('[' + item.type + ']' + item.name, item.talkback, 1)
      } else {
        this.$refs.intercomRef.open('[' + item.type + ']' + item.name, { ...item.talkback.device_no, ...item.device.gate_id }, item.device.rtsp_url, 1)
      }
    },
    handleOpenAndClose(e, gate_id, action) {
      // this.$confirm('确认' + (action ? '落' : '开') + '闸吗？', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // }).then(() => {
      let form = {
        park_id: this.park_id,
        gate_id,
        action
      }
      console.log(e)
      if (e.target.localName == 'button') {
        e.target.disabled = true
      } else if (e.target.parentElement.localName == 'button') {
        e.target.parentElement.disabled = true
      }
      // this.openAndCloseLoading = true
      API_index.postParkGateAction(form).then(() => {
        // this.openAndCloseLoading = false
        if (e.target.localName == 'button') {
          e.target.disabled = false
        } else if (e.target.parentElement.localName == 'button') {
          e.target.parentElement.disabled = false
        }
        this.$message({
          type: 'success',
          message: (action ? '落' : '开') + '闸成功!',
        })
      }).catch(() => {
        // this.openAndCloseLoading = false
        if (e.target.localName == 'button') {
          e.target.disabled = false
        } else if (e.target.parentElement.localName == 'button') {
          e.target.parentElement.disabled = false
        }
      })
    },
    handleRule(e) {
      const form = {
        car_number: this.recordsDepData.car_number,
        park_id: this.recordsDepData.park_id,
        gate_id: this.recordsDepData.gate_id,
        prop_rule_id: e,
        actual_open: 0
      }
      API_index.postRecordManualOut(form).then(res => {
        this.recordsDepData.price = res.price_info.all_price
        this.recordsDepData.pay_price = res.price_info.pay_price
        this.recordsDepData.dep_time = res.record.dep_time
        this.recordsDepData.pass_type = res.record.pass_type
      })
    },
    handlePrePay(e) {
      if (!this.ruleList.length) {
        this.$message({
          type: 'warning',
          message: '请在新平台配置计费规则',
        })
        return false
      }

      if (!e.park_id) {
        return false
      }
      let form = {
        park_id: e.park_id,
        gate_id: e.dep_gate_id || e.gate_id,
        car_number: e.car_number,
        pay_price: e.pay_price,
        pay_type: '现金',
        record_id: e.record_id,
        prop_rule_id: this.prop_rule_id,
        gate_open_log_id: e.gate_open_log_id,
        dep_param_id: e.dep_param_id,
        sign: e.sign,
      }
      this.prePayLoading = true
      API_index.getRecordAdminPrePay(form).then(() => {
        // this.getUnpay(form, false)
        this.prePayLoading = false
        this.prop_rule_id = this.ruleList[0] && Number(this.ruleList[0].id)

        this.$message({
          type: 'success',
          message: '已放行',
        })
      }).catch(() => {
        this.prePayLoading = false
      })
    },
    handelDispose(e) {
      if (!this.ruleList.length) {
        this.$message({
          type: 'warning',
          message: '请在新平台配置计费规则',
        })
        return false
      }
      this.disposeLoading = true
      const form = {
        park_id: e.park_id,
        gate_id: e.dep_gate_id || e.gate_id,
        car_number: e.car_number,
      }
      API_index.getRecordUndo(form).then(() => {
        this.disposeLoading = false
        this.disConnect();
        this.$nextTick(() => {
          this.MQTTConnect();
        })
        this.getUnpay(e, false)
        this.prop_rule_id = this.ruleList[0] && Number(this.ruleList[0].id)

        this.$message({
          type: 'success',
          message: '操作成功',
        })
      }).catch(() => {
        this.disposeLoading = false
      })
    },
    handelRefresh() {
      this.$router.go()
    },
    handleFreeOut(e) {

      if (!this.ruleList.length) {
        this.$message({
          type: 'warning',
          message: '请在新平台配置计费规则',
        })
        return false
      }
      if (!e.park_id) {
        return false
      }
      if (this.prop_rule_id === '') {
        this.$message({
          type: 'error',
          message: '请选择计费规则',
        })
        return false
      }
      if (!this.freeOut) {
        this.$message({
          type: 'error',
          message: '请选择免费放行原因',
        })
        return false
      }
      let form = {
        park_id: e.park_id,
        gate_id: e.dep_gate_id || e.gate_id,
        car_number: e.car_number,
        record_id: e.record_id,
        memo: this.freeOut,
        prop_rule_id: this.prop_rule_id,
      }
      console.log(form)
      // return false
      this.freeOutLoading = true
      API_index.postRecordManualFreeOut(form).then(() => {
        this.freeOutLoading = false
        // this.freeOut = ''
        this.recordsDepData.pay_price = ''
        this.prop_rule_id = this.ruleList[0] && Number(this.ruleList[0].id)
        this.getUnpay(this.recordsDepData, false) // 清除待处理

        this.$message({
          type: 'success',
          message: '已免费放行',
        })

      }).catch(() => {
        this.freeOutLoading = false
      })
    },
    //开闸放行
    handleFreeDirection(e) {
      let form = {
        park_id: e.park_id,
        gate_id: e.dep_gate_id || e.gate_id,
        car_number: e.car_number,
        record_id: e.record_id,
        // memo: this.freeOut,
        prop_rule_id: this.prop_rule_id,
      }
      console.log(form)
      // return false
      this.freeDirectionLoading = true
      API_index.postRecordManualFreeOut(form).then(() => {
        this.freeDirectionLoading = false
        this.recordsDepData.pay_price = ''
        this.prop_rule_id = this.ruleList[0] && Number(this.ruleList[0].id)
        this.getUnpay(this.recordsDepData, false) // 清除待处理

        this.$message({
          type: 'success',
          message: '已开闸放行',
        })

      }).catch(() => {
        this.freeDirectionLoading = false
      })
    },
    handleOutAndEnterRecord(state) {
      if (state == 'enter') {
        this.outEnterTitle = '入场记录'
      } else if (state == 'out') {
        this.outEnterTitle = '出场记录'
      } else if (state == 'bepresent') {
        this.outEnterTitle = '在场车辆'
      }
      this.$refs.dialogOutEnterRecord.init(state)
    },
    handleProhibitRecord() {
      this.$refs.dialogProhibitRecord.init()
    },
    handleUnpayRecord() {
      this.$refs.dialogUnpayRecord.init()
    },
    handleCarInfo() {
      this.$refs.dialogCarInfo.init()

    },
    handleOutEnter(type, car_number) {
      let list = []
      if (type == 'out') {
        this.outEnterTitle = '手动出场'

        for (let i in this.gateData) {
          if (this.gateData[i].type == '出口') {
            list.push(this.gateData[i])
          }
        }
      } else if (type == 'enter') {
        this.outEnterTitle = '手动入场'

        for (let i in this.gateData) {
          if (this.gateData[i].type == '入口') {
            list.push(this.gateData[i])
          }
        }
      }
      this.$refs.dialogOutEnter.init(type, list, car_number)
    },
    handlePending(data) {
      // this.outEnterTitle = '待处理'
      // this.$refs.dialogOutEnter.init('pending', '', data)
      this.recordsDepData = data
      // this.prop_rule_id = Number(this.recordsDepData.rule_id)
    },
    async confirmSentry() {
      // 清除旧的定时器
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (this.mqttReconnectTimer) {
        clearTimeout(this.mqttReconnectTimer);
      }

      // 重置重连计数
      this.mqttReconnectAttempts = 0;

      await store.dispatch('getMqtt', { park_id: this.getStore('park_id'), sentry_id: this.getStore('sentry_id') })
      this.init()
      await this.initMqttConnection();
    },
    confirmLock() {
      this.lockState = false
      if (this.gateData.length == 0) {
        this.init()
      } else {
        this.loading = false
      }
    },
    appearance(car_number) {
      this.handleOutEnter('out', car_number)

    },
    previewImg(url) {
      this.$refs.PreviewImg.init(url)
    },

    handleLoginout() {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        API_login.postUserLoginout().then(() => {
          // this.clearStore()
          this.$message({
            type: 'success',
            message: '退出登录成功!',
          })
          setTimeout(() => {
            this.$store.dispatch('loginOut').then(() => {
              // location.reload()
            })
          }, 1000)

        })
      }).catch(() => { })
    },
    handleFullScreen() {
      if (this.isFullScreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
        this.isFullScreen = false
      } else {
        const docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }

        this.isFullScreen = true
      }
    },
    handleLock() {
      this.$confirm('确认锁屏吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let form = {
          park_id: this.park_id,
        }
        API_login.getUserLock(form).then(() => {
          this.lockState = true
          this.loading = true
          this.setStore('lockState', true)
          this.$refs.dialogLock.init()
        })
      }).catch(() => { })
    }

  }
}
</script>
<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .head {
    flex-shrink: 0;
    height: 60px;
    line-height: 60px;
    padding: 0 30px;
    background-color: $primary;
    font-size: 16px;
    color: #fff;

    .head-l {
      cursor: pointer;

      i {
        margin-right: 10px;
      }

      .head-btn {
        margin-right: 24px;

        &:hover {
          opacity: 0.8;
        }
      }
    }

    .head-title {
      font-size: 30px;
    }

    button {
      width: 60px;
      height: 30px;
      border-radius: 4px;
      margin-left: 10px;
    }
  }
}

.content {
  flex: 1;
  min-height: 0;
  padding: 16px 0 14px 16px;
  overflow: hidden;
}

.video-box {
  width: 70%;
  height: 100%;
  overflow-y: auto;
  align-content: stretch;

  ul {
    align-content: stretch;
  }

  &.video-carousel,
  .video-carousel {
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }

  :deep(.el-carousel__indicators--outside) {
    margin-top: -5px;
    height: 25px;
    overflow: hidden;

    li {
      margin-top: 5px;
    }
  }

  li {
    list-style: none;
    position: relative;
    // 纵向布局：视频区随行高拉伸铺满
    display: flex;
    flex-direction: column;
    max-height: 520px;
    // 按列数自适应列宽：2列 / 3列(li3) / 4列(li4)，预留左右各 8px 间距
    width: calc(50% - 16px);

    &.li3 {
      width: calc(33.333% - 16px);
    }

    &.li4 {
      width: calc(25% - 16px);
    }

    margin: 0 8px;
    margin-bottom: 16px;

    .video-item {
      background-color: #000;
      color: #999;
      text-align: center;
      font-size: 14px;
      border: none;
      overflow: hidden;

      // 播放器容器背景统一为黑色
      :deep(.jessibuca-container) {
        background-color: #000;
      }

      label {
        margin-top: 12px;
        padding: 0 8px;
        display: inline-block;

        &.off-line {
          margin-top: 40px;
          font-size: 24px;
        }
      }
    }

    :deep(.jessibuca-controls) {
      display: none;
    }

    // 视频区域按 16:9 随列宽自适应，行有富余时拉伸铺满可视区
    .video-item,
    img {
      position: relative;
      width: 100%;
      height: auto;
      aspect-ratio: 16 / 9;
      flex: auto;
      max-height: 420px;

      :deep(video),
      :deep(canvas) {
        width: 100%;
        height: 100%;
        background-color: #000;
      }

      :deep(canvas) {
        bottom: 0;
        left: 0 !important;
        top: 0 !important;
        transform: scale(1) !important;
        margin: auto;
        object-fit: cover;
      }
    }

    .iframe {
      width: 100%;
      aspect-ratio: 16 / 9;
      overflow: hidden;

      iframe.video-item {
        width: calc(100% + 20px) !important;
        height: calc(100% + 20px) !important;
      }
    }

    // &:nth-child(odd) {
    //   margin-right: 16px;
    // }

    .funtion {
      padding: 8px;
      height: auto;
      line-height: 1.5;
      background-color: #fff;
      flex-wrap: wrap;

      .funtion-title {
        font-size: 16px;
        font-weight: bold;
        flex: none
      }

      .funtion-button {
        margin-top: 4px;
        // 所有按钮排成一行，放不下时文字收缩省略
        justify-content: space-between;
        gap: 0 4px;

        >div {
          display: flex;
          min-width: 0;
          gap: 0 4px;
        }

        .el-button {
          flex: 0 1 auto;
          min-width: 0;
          padding: 0 8px;
          font-size: 12px;
          margin-left: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  // img,
  // video {
  //   width: 100%;
  //   // height: 385px;
  //   // object-fit: cover;
  // }
}

:deep(.el-input__inner) {
  color: #000;
  font-size: 16px;
}

.info {
  width: 30%;
  height: 100%;
  overflow-y: auto;
  font-size: 18px;

  .info-statistics {
    background-color: #fff;
    padding: 22px 30px;
    text-align: center;
    margin-bottom: 15px;
    flex-wrap: wrap;

    label {
      color: $primary;
    }

    li:first-child {
      label {
        color: $warning;
      }
    }
  }

  .info-car {
    padding: 5px 30px;
    background-color: #fff;
    min-height: calc(100vh - 98px - 60px - 125px);

    .info-car-title {
      height: 50px;
      line-height: 50px;
      color: $primary;
      border-bottom: 1px solid $primary;

      .pending {
        li {
          line-height: 60px;
        }
      }
    }

    .info-car-data {
      padding: 20px 0;

      .info-time {
        font-size: 16px;
      }

      li {
        width: 50%;
        margin: 5px 0;

        label {
          width: 5em;
        }

        .el-image {
          width: 0;
          height: 0;
        }

        p {
          flex: 1;

          &.preview-img {
            color: $primary;
            cursor: pointer;
          }
        }

        &.info-car-cost {

          // padding: 20px 0;
          p {
            display: inline-block;
            margin-top: 20px;
            font-size: 30px;
            font-weight: bold;
            color: $danger;
          }
        }

        &.quick {
          // .el-button {
          //   position: absolute;
          //   margin-top: -30px;
          // }
        }
      }

      .info-car-button {
        margin-bottom: 20px;

        .el-button {
          width: 120px;
          height: 45px;
          border-radius: 0;
        }
      }
    }
  }
}

.flex-100 {
  width: 100% !important;
}

/* 窄屏时上下堆叠 */
@media screen and (max-width: 1200px) {
  .content {
    flex-direction: column;
    overflow-y: auto;
    padding: 12px 16px;
  }

  .video-box,
  .info {
    width: 100%;
    height: auto;
    overflow: visible;
  }

  .footer {
    font-size: 16px;

    ul {
      flex-wrap: wrap;
      row-gap: 4px;
    }

    li {
      padding: 0 8px;
    }
  }
}

.footer {
  flex-shrink: 0;
  padding: 10px 16px;
  background-color: #fff;
  font-size: 18px;

  ul {
    display: flex;
    flex: 1;
    justify-content: space-around;

    li {
      color: #000;
      border-right: 1px solid #ccd5dd;
      padding: 0 12px;
      display: flex;
      align-items: center;
      cursor: pointer;
      white-space: nowrap;

      i {
        font-size: 22px;
        margin-right: 5px;
      }

      &:last-child {
        border-right: 0;
      }
    }
  }
}
</style>

<style>
.vjs-loading-spinner,
.vjs-big-play-button,
.vjs-control-bar,
.vjs-modal-dialog {
  display: none;
}

.el-carousel {
  width: 100%;
}
</style>
